import React, { useState } from 'react'
import useTrans from '@hooks/useTrans'
import { cn, getUserType } from '@utils/safeTs'
import { PersonalizzazioneOrdineType, PosizionePersonalizzazioneType, RootStateType } from '@utils/types'
import { CronologiaButton, MyAccountImagePreview } from '@components/atoms'
import FlussoPersonalizzazionePosizione from '../FlussoPersonalizzazionePosizione/FlussoPersonalizzazionePosizione'
import styles from './FlussoPersonalizzazioneLoghiPosizione.module.sass'
import FlussoPersonalizzazionePosizioneConfigurazione from '../FlussoPersonalizzazionePosizioneConfigurazione/FlussoPersonalizzazionePosizioneConfigurazione'
import MyAccountStatusLogModal from '../MyAccountStatusLogModal/MyAccountStatusLogModal'
import { useSelector } from 'react-redux'


interface Props {
  posizione: PosizionePersonalizzazioneType
  personalizzazione: PersonalizzazioneOrdineType
  personalizzazioniOpen?: number[]
  setPersonalizzazioniOpen: React.Dispatch<React.SetStateAction<number[]>>
  posizioniOpen: number[]
  setPosizioniOpen: React.Dispatch<React.SetStateAction<number[]>>
  className?: string
}

const FlussoPersonalizzazioneLoghiPosizione = (props: Props) => {

  const { 
    posizione,
    personalizzazione,
    posizioniOpen,
    setPosizioniOpen,
    className = '',
  } = props
  
  const t = useTrans()
  const { utente } = useSelector((state: RootStateType) => state.utente)
  const userType = getUserType(utente)
  const [logOpen, setLogOpen] = useState(false)

  return (
    <FlussoPersonalizzazionePosizione 
      posizione={posizione} 
      posizioniOpen={posizioniOpen} 
      setPosizioniOpen={setPosizioniOpen} 
      userType={userType}
      className={cn(styles.root, className)}
    >
      <div className={styles.row}>
        <FlussoPersonalizzazionePosizioneConfigurazione 
          posizione={posizione} 
          personalizzazione={personalizzazione}
          className={cn(styles.section, styles['section--configurazione'])} 
        />
      </div>
      <div className={styles.row}>
        <div className={cn(styles.section, styles['section--loghi'])}>
          <p className={styles.sectionTitle}>{t('Logo')}</p>
          {posizione.loghi?.length ? (
            <div className={styles.loghiList}>
              {posizione.loghi.concat(posizione.loghi).concat(posizione.loghi).map(logo => (
                <MyAccountImagePreview 
                  url={logo?.url} 
                  name={logo?.name}
                  previewName={t("logo")}
                  className={styles.logoPreview}
                />
              ))}
            </div>
          ) : (
            <div className={styles.loghiEmpty}>
              {t("Nessun logo impostato")}
            </div>
          )}
        </div>
          
        <div className={cn(styles.section, styles['section--note'])}>
          <p className={styles.sectionTitle}>
            <span>{t('Nota')}</span>
            <CronologiaButton onClick={() => setLogOpen(true)} />
          </p>
          <div className={styles.formValue}>
            {posizione.log?.filter(l => l.stato === posizione.statoPosizionePersonalizzazione)?.length ? (
              posizione.log.filter(l => l.stato === posizione.statoPosizionePersonalizzazione)?.[posizione.log.filter(l => l.stato === posizione.statoPosizionePersonalizzazione)?.length - 1].note || '-'
            ) : '-'}
          </div>
        </div>
      </div>
      <MyAccountStatusLogModal id={`status_log_modal_${posizione.id}`} open={logOpen} onClose={() => setLogOpen(false)} posizione={posizione} userType={userType} />
    </FlussoPersonalizzazionePosizione>
  )
}

export default FlussoPersonalizzazioneLoghiPosizione
